import { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getList } from '../services';
import { LoVNode } from '../utils/types';

export function useList() {
  const { apiDomain } = useFlags();
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState<LoVNode[] | []>([]);

  useEffect(() => {
    getList(apiDomain)
      .then(setList)
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, []);
  return { list, isLoading };
}
